(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dbs-lunchbox-motifs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dbs-lunchbox-motifs')) {
    customElements.define('dbs-lunchbox-motifs', class extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('product-info') || this.parentElement;
        const enhance = () => {
          if (this.enhanced) return;
          const field = scope.querySelector('input.gpo-text[data-field-name^="Motivnummer"]');
          const group = field?.closest('.gpo-element');
          const wrap = field?.closest('.gpo-input-wrap');
          const select = this.querySelector('select');
          const overview = this.querySelector('details');
          if (!field || !group || !wrap || !select || !overview) return;
          select.value = field.value.trim();
          wrap.insertBefore(select, field);
          group.appendChild(overview);
          select.hidden = false;
          field.hidden = true;
          const label = group.querySelector('label');
          if (label) {
            label.htmlFor = select.id;
            const text = label.querySelector('.label-content') || label;
            text.textContent = this.dataset.heading;
          }
          select.addEventListener('change', () => {
            field.value = select.value;
            field.dispatchEvent(new Event('input', { bubbles: true }));
            field.dispatchEvent(new Event('change', { bubbles: true }));
          });
          this.enhanced = true;
          this.hidden = true;
          this.observer?.disconnect();
        };
        this.observer = new MutationObserver(enhance);
        this.observer.observe(scope, { childList: true, subtree: true });
        enhance();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
